import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_bedding: FaireCategoryEntity = {
  token: "cat_home-decor-bedding",
  type: "category",
  name: "Bedding",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor/bedding",
  childCategoryTokens: [
    "cat_bedding-all",
    "cat_bedding-blankets",
    "cat_bedding-pillows",
    "cat_bedding-quilts",
    "cat_bedding-sheets",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
